export default {
  "content": "<path d=\"M15.5 13.5a1.5 1.5 0 110 3 1.5 1.5 0 010-3z\" fill=\"#7B61FF\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M18.72 10a2 2 0 011.94 1.515l1.5 6A2 2 0 0120.22 20H3.781a2 2 0 01-1.94-2.485l1.5-6A2 2 0 015.281 10h13.437zM3.781 18h16.437l-1.5-6H5.282l-1.5 6z\" fill=\"#7B61FF\"/><path d=\"M21.368 3.996l-1.712 2.996A2 2 0 0117.919 8H6.08c-.717 0-1.38-.385-1.736-1.008L2.631 3.996l1.737-.992L6.079 6h11.84l1.712-2.996 1.737.992z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};